// Ports the production-type, stage, site, and product-id machinery from the Angular
// `corp-frontend-v2`. Values must match Angular byte-for-byte so the React app talks to the
// same backend identifiers (system UUIDs, product UUIDs, stage names).
//
// Sources:
//   - corp-frontend-v2/projects/agriness/services/src/lib/models/system.model.ts (TypeProductionEnum, systemType)
//   - corp-frontend-v2/projects/agriness/services/src/lib/models/user.model.ts (StageEnum, StageEnumBff, SiteEnum)
//   - corp-frontend-v2/projects/agriness/corp-app/src/lib/corp-app.model.ts (IdsByProductionType, appInfoByProduction)

export enum TypeProductionEnum {
  SWINES = 'swines',
  POULTRY = 'poultry',
  DAIRY = 'dairy',
  LAYERS = 'layers',
}

export enum StageEnum {
  FINISHING = 'finishing',
  REPRODUCTIVE = 'reproductive',
  NURSERY = 'nursery',
  WEAN_TO_FINISH = 'wean-to-finish',
  GROW_OUT = 'grow_out',
  MILKING = 'milking',
  LAYERS_PRODUCTION = 'layers-production',
}

// Snake-case variant used in BFF/backend requests where the URL/query string convention differs.
export enum StageEnumBff {
  FINISHING = 'finishing',
  REPRODUCTIVE = 'reproductive',
  NURSERY = 'nursery',
  WEAN_TO_FINISH = 'wean_to_finish',
  GROW_OUT = 'grow_out',
  MILKING = 'milking',
  LAYERS_PRODUCTION = 'layers_production',
}

export enum SiteEnum {
  SITE_1 = 'site_1',
  SITE_2 = 'site_2',
  SITE_3 = 'site_3',
  SITE_4 = 'site_4',
}

// System UUIDs from systemType map in Angular system.model.ts.
export const SystemTypeIds: { [K in TypeProductionEnum]: string } = {
  [TypeProductionEnum.SWINES]: '95a5b8c5-fd06-4718-a440-d3024ff161e5',
  [TypeProductionEnum.POULTRY]: '32990f9d-43a5-4554-a645-e36720141df7',
  [TypeProductionEnum.DAIRY]: '6bc88e6c-3eb6-4fc2-86b9-58818ff945a1',
  [TypeProductionEnum.LAYERS]: '74901aea-b4ed-45db-8a42-6c98e34d78fc',
};

// Product UUIDs (corp product per production type) from Angular corp-app.model.ts.
export const IdsByProductionType: { [K in TypeProductionEnum]: string } = {
  [TypeProductionEnum.SWINES]: '6bc88e6c-3eb6-4fc2-86b9-58818ff945a1',
  [TypeProductionEnum.POULTRY]: 'ef8aca88-ebe9-4f39-90c2-88391cf4bc1e',
  [TypeProductionEnum.DAIRY]: '4cb131a0-a6d9-4b0b-882e-4ca17b67dae9',
  [TypeProductionEnum.LAYERS]: '8248950c-3f29-4d1b-8c00-5f2557d7ed91',
};

export interface AppInfo {
  typeProduction: TypeProductionEnum;
  productId: string;
  iconTitle: string;
}

// Per-production app metadata. Icon titles match Angular `iconTitle` strings byte-for-byte.
export const appInfoByProduction: { [K in TypeProductionEnum]: AppInfo } = {
  [TypeProductionEnum.SWINES]: {
    typeProduction: TypeProductionEnum.SWINES,
    productId: IdsByProductionType.swines,
    iconTitle: 'swine-logo',
  },
  [TypeProductionEnum.POULTRY]: {
    typeProduction: TypeProductionEnum.POULTRY,
    productId: IdsByProductionType.poultry,
    iconTitle: 'broiler-logo',
  },
  [TypeProductionEnum.DAIRY]: {
    typeProduction: TypeProductionEnum.DAIRY,
    productId: IdsByProductionType.dairy,
    iconTitle: 'dairy-logo',
  },
  [TypeProductionEnum.LAYERS]: {
    typeProduction: TypeProductionEnum.LAYERS,
    productId: IdsByProductionType.layers,
    iconTitle: 'layers-logo',
  },
};

export const productIds = new Set(Object.values(appInfoByProduction).map((i) => i.productId));
